import React, { useEffect, useRef, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import Checkbox from "./../../../component/atoms/input/checkbox";
import RedBtn from "../../../component/atoms/button/redBtn";
import GrayBtn from "../../../component/atoms/button/grayBtn";
import styled from "styled-components";
import PretendardText from "../../../component/atoms/text/pretendardText";
import MainInput from "./../../../component/atoms/input/mainInput";
import { useNavigate, useParams } from "react-router-dom";
import SelectBox from "../../../component/organisms/selectBox";
import BasicBtn from "./../../../component/atoms/button/basicBtn";
import TextFormEditor from "../../../component/atoms/input/textFormEditor";
import scrollToTop from "../../../util/scrollToTop";
import ChapterApi from "../../../api/chapter.api";
import { errorHandler } from "../../../util/errorHandler";
import { toast } from "react-toastify";
import FileApi from "../../../api/file.api";
import ProductApi from "./../../../api/product.api";
import { route } from "../../../router/route";

// TODO:
// - 추후 미리보기 페이지 구현 필요 (프리뷰 페이지 별도로 만들어야 할듯)
// - 강의, 전자책 식별 id 값으로 진행하고 있음 (추후에 변경 가능성 있는 점 참고)

const ShoppingProductChapterCreate = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    // 편집 권한 체크
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (!writeMenu?.includes(route.shopping_product)) {
      navigate(-1);
      toast(
        <>
          편집 권한이 없습니다.
          <br />
          최고관리자에게 문의하세요.
        </>
      );
      return;
    }

    getProductInfo();
    getChapterTitleList();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 대제목 관련 ---------- //
  const [chapterTitleList, setChapterTitleList] = useState([]);
  const [selectedChapterTitle, setSelectedChapterTitle] = useState({
    id: "",
    title: "",
  });
  const [chapterTitleBoxOpen, setChapterTitleBoxOpen] = useState(false);

  // 상품 정보 가져오기
  const [productInfo, setProductInfo] = useState({});

  const getProductInfo = async () => {
    try {
      const response = (await ProductApi.getByIdProduct(id)).data.data.content;

      setProductInfo(response);
    } catch (error) {
      errorHandler(error);
    }
  };

  // 대제목 리스트 가져오기
  const getChapterTitleList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        sort: "orderNumber",
        merchId: id,
        orderBy: "ASC",
      };

      const response = (await ChapterApi.getListChapterTitle(data)).data.data
        .content;

      const processedResponse = response.map((item) => {
        return {
          id: item.id,
          title: item.title,
        };
      });

      setChapterTitleList(processedResponse);
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 소제목 관련 ---------- //
  const [chapterData, setChapterData] = useState({
    merchId: id,
    chapterTitleId: "",
    title: "",
    videoOriginFileName: "",
    videoServerFileName: "",
    content: "",
    isPreview: false,
    merchType: "SHOP",
  });

  useEffect(() => {
    setChapterData({
      ...chapterData,
      chapterTitleId: selectedChapterTitle.id,
    });
  }, [selectedChapterTitle]); // eslint-disable-line react-hooks/exhaustive-deps

  const createChapter = async () => {
    try {
      if (!chapterData.chapterTitleId) {
        toast("대제목을 선택해 주세요.");
        return;
      } else if (!chapterData.title) {
        toast("소제목을 입력해 주세요.");
        return;
      } else if (
        (productInfo?.merchMainCategory?.id === 2 ||
          productInfo?.merchMainCategory?.title === "강의") &&
        !chapterData.videoOriginFileName
      ) {
        toast("영상 파일을 업로드해 주세요.");
        return;
      } else if (!chapterData.content) {
        toast("상세 내용을 입력해 주세요.");
        return;
      }

      if (videoFile) {
        const response = await FileApi.fileUpload(videoFile, "admin/chapter");

        const data = {
          ...chapterData,
          videoOriginFileName: videoFile.name,
          videoServerFileName: response.data.data.serverFileName,
        };

        await ChapterApi.createChapter(data);
        toast("목차가 추가되었습니다.");
        navigate(-1);
        setVideoFile(null);
      } else {
        await ChapterApi.createChapter(chapterData);
        toast("목차가 추가되었습니다.");
        navigate(-1);
      }
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 영상 파일 관련 ---------- //
  const [videoFile, setVideoFile] = useState(null);

  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0]; // 선택된 파일

    if (file) {
      setChapterData({
        ...chapterData,
        videoOriginFileName: file.name,
      });

      setVideoFile(file);
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // input의 value를 초기화하여 같은 파일 선택 가능하게 함
    }
  };

  const deleteVideoFile = () => {
    fileInputRef.current.value = "";
    setChapterData({
      ...chapterData,
      videoOriginFileName: "",
      videoServerFileName: "",
    });
  };

  const handleUploadClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  // ---------- 텍스트 에디터 관련 ---------- //
  const [isLoading, setIsLoading] = useState(false);

  // ---------- 미사용 ---------- //
  // const [TemporaryPopupOpen, setTemporaryPopupOpen] = useState(false);

  // const [uploadPopupOpen, setUploadPopupOpen] = useState(false);
  // const [uploadTime, setUploadTime] = useState("지금");

  // const [uploadTimeValue, setUploadTimeValue] = useState("");

  // const [hourBoxOpen, setHourBoxOpen] = useState(false);
  // const [selectedHour, setSelectedHour] = useState("");

  // const [minuteBoxOpen, setMinuteBoxOpen] = useState(false);
  // const [selectedMinute, setSelectedMinute] = useState("");

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 본문 영역 */}
        <DetailPageLayout
          style={{
            position: "relative",
          }}
        >
          <TableTitle>목차 추가</TableTitle>

          {/* 대제목 영역 */}
          <BasicContentSettingInputWrapper
            style={{
              padding: "21px 0px",
            }}
          >
            <BasicContentSettingInputTitle>
              대제목
            </BasicContentSettingInputTitle>
            <SelectBox
              placeholder="대제목을 선택해 주세요"
              selectedValue={selectedChapterTitle.title}
              isOpen={chapterTitleBoxOpen}
              wrapperHandler={() => {
                setChapterTitleBoxOpen(!chapterTitleBoxOpen);
              }}
              itemList={chapterTitleList}
              selectedValueSetterFunc={setSelectedChapterTitle}
            />
          </BasicContentSettingInputWrapper>

          {/* 소제목 영역 */}
          <BasicContentSettingInputWrapper
            style={{
              padding: "21px 0px",
            }}
          >
            <BasicContentSettingInputTitle>
              소제목
            </BasicContentSettingInputTitle>
            <MainInput
              type={"text"}
              placeholder={"소제목을 입력해 주세요."}
              style={{ width: "572px" }}
              value={chapterData.title}
              onChange={(e) => {
                setChapterData({
                  ...chapterData,
                  title: e.target.value,
                });
              }}
            />
          </BasicContentSettingInputWrapper>

          {/* 영상 파일 영역 */}
          {/* {(productInfo?.merchMainCategory?.id === 2 ||
            productInfo?.merchMainCategory?.title === "강의") && ( */}
          <>
            <BasicContentSettingInputWrapper
              style={{
                padding: "21px 0px",
              }}
            >
              <BasicContentSettingInputTitle>
                영상 파일
              </BasicContentSettingInputTitle>
              {chapterData.videoOriginFileName !== "" && (
                <>
                  <PretendardText
                    style={{
                      fontWeight: 500,
                      fontSize: 14,
                      lineHeight: "21px",
                      color: "#999",
                      marginRight: 20,
                    }}
                  >
                    {chapterData.videoOriginFileName}
                  </PretendardText>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                    }}
                  >
                    <RedBtn onClick={deleteVideoFile}>삭제</RedBtn>
                    <GrayBtn onClick={handleUploadClick}>영상 업로드</GrayBtn>
                  </div>
                </>
              )}
              {chapterData.videoOriginFileName === "" && (
                <GrayBtn onClick={handleUploadClick}>영상 업로드</GrayBtn>
              )}
            </BasicContentSettingInputWrapper>
            <input
              type="file"
              accept=".wmv, .avi, .mov, .mpeg, .mp4" // 동영상 파일만 허용
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
          </>
          {/* )} */}

          {/* 미리보기 영역 */}
          {productInfo?.merchMainCategory?.id !== 3 &&
            productInfo?.merchMainCategory?.id !== 4 &&
            productInfo?.merchMainCategory?.id !== 5 && (
              <BasicContentSettingInputWrapper
                style={{
                  padding: "21px 0px",
                  alignItems: "flex-start",
                }}
              >
                <BasicContentSettingInputTitle>
                  미리보기
                </BasicContentSettingInputTitle>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 5,
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <Checkbox
                      checked={chapterData.isPreview}
                      onChange={() => {
                        setChapterData({
                          ...chapterData,
                          isPreview: !chapterData.isPreview,
                        });
                      }}
                    />
                    <PretendardText
                      style={{
                        fontWeight: 500,
                        fontSize: 15,
                        lineHeight: "21.5px",
                        color: "#aaa",
                      }}
                    >
                      미리보기 시에 이 소목차를 일부 공개로 노출
                    </PretendardText>
                  </div>
                  <PretendardText
                    style={{
                      fontWeight: 500,
                      fontSize: 13,
                      lineHeight: "18.72px",
                      color: "rgba(181, 181, 181, 0.5)",
                      paddingLeft: 30,
                    }}
                  >
                    지식상점 전자책 & 강의 상품에만 적용됩니다
                  </PretendardText>
                </div>
              </BasicContentSettingInputWrapper>
            )}

          <TextFormEditor
            placeholder={"상세 내용을 입력해주세요"}
            value={chapterData.content}
            isLoading={isLoading}
            setIsLoading={setIsLoading}
            onChange={(contents) => {
              setChapterData({
                ...chapterData,
                content: contents,
              });
            }}
            editorHeight={668}
            style={{
              width: "100%",
              marginTop: "24px",
            }}
          />
          <div
            style={{
              width: "100%",
              height: 79,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              gap: 12,
            }}
          >
            <BasicBtn
              isTransparent={true}
              onClick={() => {
                navigate(-1);
                scrollToTop();
              }}
            >
              이전으로
            </BasicBtn>
            {/* <BasicBtn isBlue={true} onClick={() => {}}>
              미리보기
            </BasicBtn>
            <DividedBtn
              onClick={() => {}}
              text1="임시저장"
              text2="3"
              textHandler={() => {
                setTemporaryPopupOpen(true);
              }}
            /> */}
            <BasicBtn onClick={createChapter}>업로드하기</BasicBtn>
          </div>

          {/* {uploadPopupOpen && (
            <Popup
              style={{
                position: "absolute",
                bottom: 65,
                right: 0,
              }}
              headerTitle="업로드 설정"
              onClick={() => {
                setUploadPopupOpen(false);
              }}
              footerBtnText="최종 업로드하기"
              footerBtnHandler={() => {}}
            >
              <div
                style={{
                  width: "100%",
                  height: 400,
                  display: "flex",
                  flexDirection: "column",
                  marginTop: 32,
                  padding: "0px 30px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <BasicContentSettingInputTitle>
                    업로드 시간
                  </BasicContentSettingInputTitle>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 20,
                    }}
                  >
                    <Radio
                      id={""}
                      valueText={"지금"}
                      checked={uploadTime === "지금"}
                      onChange={() => {
                        setUploadTime("지금");
                      }}
                    />
                    <Radio
                      id={""}
                      valueText={"예약"}
                      checked={uploadTime === "예약"}
                      onChange={() => {
                        setUploadTime("예약");
                      }}
                    />
                  </div>
                </div>
                {uploadTime === "예약" && (
                  <div
                    style={{
                      width: "100%",
                      padding: "0px 0px 0px 122px",
                      display: "flex",
                      flexDirection: "column",
                      marginTop: 24,
                    }}
                  >
                    <PretendardText
                      style={{
                        fontWeight: 500,
                        fontSize: 13,
                        lineHeight: "18.75px",
                        color: "#aaa",
                        marginBottom: 10,
                      }}
                    >
                      예약한 시간에 업로드 됩니다
                    </PretendardText>
                    <DateInput
                      value={uploadTimeValue}
                      onChange={(e) => {
                        setUploadTimeValue(e.target.value);
                      }}
                    />
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 20,
                        marginTop: 16,
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <SelectBox
                          isSmall={true}
                          placeholder="00"
                          selectedValue={selectedHour}
                          isOpen={hourBoxOpen}
                          wrapperHandler={() => {
                            setHourBoxOpen(!hourBoxOpen);
                          }}
                          itemList={hourList}
                          selectedValueSetterFunc={setSelectedHour}
                        />
                        <PretendardText
                          style={{
                            fontWeight: 500,
                            fontSize: 15,
                            lineHeight: "21.5px",
                            color: "#aaa",
                          }}
                        >
                          시
                        </PretendardText>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <SelectBox
                          isSmall={true}
                          placeholder="00"
                          selectedValue={selectedMinute}
                          isOpen={minuteBoxOpen}
                          wrapperHandler={() => {
                            setMinuteBoxOpen(!minuteBoxOpen);
                          }}
                          itemList={minuteList}
                          selectedValueSetterFunc={setSelectedMinute}
                        />
                        <PretendardText
                          style={{
                            fontWeight: 500,
                            fontSize: 15,
                            lineHeight: "21.5px",
                            color: "#aaa",
                          }}
                        >
                          분
                        </PretendardText>
                      </div>
                    </div>
                  </div>
                )}
                <div
                  style={{
                    display: "flex",
                    marginTop: 32,
                  }}
                >
                  <BasicContentSettingInputTitle>
                    미리보기
                  </BasicContentSettingInputTitle>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 5,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                      }}
                    >
                      <Checkbox checked={false} onChange={() => {}} />
                      <PretendardText
                        style={{
                          fontWeight: 500,
                          fontSize: 15,
                          lineHeight: "21.5px",
                          color: "#aaa",
                        }}
                      >
                        미리보기 시에 이 소목차를 일부 공개로 노출
                      </PretendardText>
                    </div>
                    <PretendardText
                      style={{
                        fontWeight: 500,
                        fontSize: 13,
                        lineHeight: "18.72px",
                        color: "rgba(181, 181, 181, 0.5)",
                        paddingLeft: 30,
                      }}
                    >
                      지식상점 전자책 & 강의 상품에만 적용됩니다
                    </PretendardText>
                  </div>
                </div>
              </div>
            </Popup>
          )} */}
        </DetailPageLayout>
      </MainLayout>

      {/* {TemporaryPopupOpen && (
        <PopupOverLay
          isOpen={true}
          onClick={() => {
            setTemporaryPopupOpen(false);
          }}
        >
          <Popup
            headerTitle="임시저장 글"
            noFooter={true}
            onClick={() => {
              setTemporaryPopupOpen(false);
            }}
          >
            <div
              style={{
                width: "100%",
                height: 279,
                display: "flex",
                flexDirection: "column",
                marginTop: 16,
                padding: "0px 30px",
              }}
            >
              {[...Array(3)].map((_, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      width: "100%",
                      height: 93,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "15px 0px",
                      borderBottom:
                        "0.5px solid var(--outline1, rgba(255, 255, 255, 0.12))",
                    }}
                  >
                    <div
                      key={index}
                      style={{
                        width: 515,
                        height: 63,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <PretendardText
                        className="truncate"
                        style={{
                          width: "100%",
                          fontWeight: 500,
                          fontSize: 14,
                          lineHeight: "22px",
                          letterSpacing: "-0.3%",
                          color: "#aaa",
                        }}
                      >
                        1. 챗GPT 시대, 어떻게 공부하나요?
                      </PretendardText>
                      <PretendardText
                        className="truncate"
                        style={{
                          width: "100%",
                          fontWeight: 500,
                          fontSize: 14,
                          lineHeight: "22px",
                          letterSpacing: "-0.3%",
                          color: "#aaa",
                        }}
                      >
                        1-1. 이제 답만 외우기만하는 교육은 끝났습니다
                      </PretendardText>
                      <PretendardText
                        className="truncate"
                        style={{
                          width: "100%",
                          fontWeight: 500,
                          fontSize: 13,
                          lineHeight: "18.75px",
                          color: "rgba(181, 181, 181, 0.5)",
                        }}
                      >
                        2024-06-30 20:48
                      </PretendardText>
                    </div>
                    <RedBtn>삭제</RedBtn>
                  </div>
                );
              })}
            </div>
          </Popup>
        </PopupOverLay>
      )} */}
    </>
  );
};

export default ShoppingProductChapterCreate;

const BasicContentSettingInputWrapper = styled.div.attrs((props) => {})`
  width: 100%;
  height: fit-content;
  display: flex;
  align-items: center;
  border-bottom: 0.5px solid var(--outline1, rgba(255, 255, 255, 0.12));
`;

const BasicContentSettingInputTitle = styled(PretendardText).attrs(
  (props) => {}
)`
  width: 122px;
  height: fit-content;
  font-weight: 600;
  font-size: 14px;
  line-height: 22.75px;
  color: #aaa;
`;
